export const BatchUploadActions = {
  GRAIN_RECEPTION: 'grain-reception',
  INTERNAL_TRANSFER: 'internal-transfer',
  EXTERNAL_TRANSFER: 'external-transfer',
  LOAN_TRANSFER: 'loan-transfer'
};
